import shiftsCheckboxSelectorUrl from './shiftsCheckboxSelector.html';
class shiftsCheckboxSelectorController {
  $onInit() {
    this.selectOptions = ['all', 'unpublished', 'available', 'unassigned'];
  }
}

export default {
  templateUrl: shiftsCheckboxSelectorUrl,
  controller: shiftsCheckboxSelectorController,
  controllerAs: 'ctrl',
  bindings: {
    isSelected: '<',
    selectedValue: '@',
    selectAction: '&',
  },
};
